import ReactApexChart from 'react-apexcharts'

import { PlanData } from './types'

type PlansComparisonChartProps = {
  plansData: PlanData[]
}

export const PlansComparisonChart: React.FC<PlansComparisonChartProps> = ({
  plansData,
}) => {
  // Only show the first three plans
  const topThreePlans = plansData.slice(0, 3)
  return (
    <div className='bg-white rounded-xl shadow-md p-6 mb-6 overflow-hidden'>
      <h2 className='text-lg font-semibold text-gray-700 mb-6'>
        Comparativo de Planos
      </h2>
      <div className='overflow-x-auto'>
        <ReactApexChart
          type='bar'
          height={350}
          width='100%'
          options={{
            chart: {
              type: 'bar',
              stacked: false,
              toolbar: {
                show: false,
              },
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '55%',
                borderRadius: 4,
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent'],
            },
            xaxis: {
              categories: topThreePlans.map((plan) => plan.planName),
            },
            yaxis: {
              title: {
                text: 'Quantidade',
              },
            },
            fill: {
              opacity: 1,
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return val + ' assinaturas'
                },
              },
            },
            legend: {
              position: 'top',
              horizontalAlign: 'left',
            },
            colors: ['#4f46e5', '#10b981', '#f59e0b', '#ef4444'],
          }}
          series={[
            {
              name: 'Total de Assinaturas',
              data: topThreePlans.map((plan) => plan.totalSubscriptions),
            },
            {
              name: 'Clientes com assinaturas',
              data: topThreePlans.map((plan) => plan.distinctCustomers),
            },
            {
              name: 'Clientes Ativos',
              data: topThreePlans.map((plan) => plan.activeNowCustomers),
            },
            {
              name: 'Assinaturas Canceladas',
              data: topThreePlans.map((plan) => plan.canceledSubscriptions),
            },
          ]}
        />
      </div>
    </div>
  )
}
